import React from 'react';
import { Badge } from '../../../components/ui/badge';
import { Users } from 'lucide-react';

export const TechnicianHistoryView = ({ data, year }) => {
  if (!data) return <div className="flex-1 flex items-center justify-center text-slate-400">Se incarca...</div>;
  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4" data-testid="technicians-view">
      <h2 className="text-lg font-bold text-slate-900">Istoric validari tehnicieni - {year}</h2>

      {data.technicians.length === 0 ? (
        <div className="border-2 border-dashed rounded-xl p-10 text-center">
          <Users className="w-10 h-10 mx-auto mb-2 text-slate-200" />
          <p className="text-sm text-slate-500">Nicio validare inregistrata</p>
        </div>
      ) : (
        <div className="border rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 border-b">
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500">#</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500">Tehnician</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500">Validari</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500">QR</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500">Utilaje</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500">Luni active</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500">Prima</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500">Ultima</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {data.technicians.map((t, i) => (
                <tr key={i} className="hover:bg-slate-50">
                  <td className="px-4 py-3 text-slate-400">{i + 1}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                        <span className="text-xs font-bold text-blue-700">{(t.technician_name || '?')[0]}</span>
                      </div>
                      <span className="font-medium text-slate-800">{t.technician_name}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center"><Badge className="bg-emerald-100 text-emerald-700">{t.validations}</Badge></td>
                  <td className="px-4 py-3 text-center"><Badge className="bg-blue-100 text-blue-700">{t.qr_validations}</Badge></td>
                  <td className="px-4 py-3 text-center text-slate-600">{t.equipment_count}</td>
                  <td className="px-4 py-3 text-center text-slate-600">{t.months_active}</td>
                  <td className="px-4 py-3 text-xs text-slate-500 font-mono">{t.first_validation || '—'}</td>
                  <td className="px-4 py-3 text-xs text-slate-500 font-mono">{t.last_validation || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
